import React, { useState } from 'react';
import { TextField, Autocomplete, Typography, Box, Grid } from '@mui/material';
import BaseModal from './BaseModal';

const months = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
];

const currentYear = new Date().getFullYear();
const years = Array.from({ length: 5 }, (_, i) => ({
  value: currentYear - i,
  label: (currentYear - i).toString(),
}));

const MonthlyModal = ({ open, onClose, onSubmit, loading, reportType }) => {
  const [filters, setFilters] = useState({
    month: null,
    year: null,
  });

  const handleMonthChange = (event, value) => {
    setFilters((prev) => ({ ...prev, month: value }));
  };

  const handleYearChange = (event, value) => {
    setFilters((prev) => ({ ...prev, year: value }));
  };

  const handleSubmit = () => {
    const { month, year } = filters;

    if (!month || !year) return;

    // Calculate first day of the month (month is 0-indexed, so subtract 1)
    const startDate = new Date(year.value, month.value - 1, 1);

    // Calculate last day of the month (day 0 of next month = last day of current month)
    const endDate = new Date(year.value, month.value, 0);

    // Format dates to YYYY-MM-DD format
    const formatDate = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // +1 because getMonth() is 0-indexed
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const payload = {
      trainingTypeName: 'all',
      startDate: formatDate(startDate),
      endDate: formatDate(endDate),
    };

    console.log('MonthlyModal payload:', payload);
    onSubmit(payload);
  };

  const handleClose = () => {
    setFilters({
      month: null,
      year: null,
    });
    onClose();
  };

  const isSubmitDisabled = !filters.month || !filters.year;

  return (
    <BaseModal
      open={open}
      onClose={handleClose}
      onSubmit={handleSubmit}
      loading={loading}
      reportType={reportType}
      submitDisabled={isSubmitDisabled}
    >
      <Box sx={{ mb: 4 }}>
        <Typography variant="h6" sx={{ mb: 2, color: 'text.primary', fontWeight: 600 }}>
          Select Filters
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              Month *
            </Typography>
            <Autocomplete
              options={months}
              getOptionLabel={(option) => option.label}
              value={filters.month}
              onChange={handleMonthChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select month"
                  variant="outlined"
                  fullWidth
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 1.5,
                    },
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 500 }}>
              Year *
            </Typography>
            <Autocomplete
              options={years}
              getOptionLabel={(option) => option.label}
              value={filters.year}
              onChange={handleYearChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select year"
                  variant="outlined"
                  fullWidth
                  size="small"
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 1.5,
                    },
                  }}
                />
              )}
            />
          </Grid>
        </Grid>
      </Box>
    </BaseModal>
  );
};

export default MonthlyModal;
